export function getPartnership(partnership: string | null) {
  if (!partnership || partnership === 'null') {
    return null;
  } else if (partnership === 'SPP') {
    return 'C1';
  }

  return partnership;
}
